module.exports = __webpack_public_path__ + "img/domains.ff037392.svg";